<section class="content-area-layout2">
    <h3>Application Info</h3>
    <p>{{appName}} - {{appVersion}}</p>
</section>